import { z } from "zod";
import { User } from "../users";
import { WorkspaceDump } from "./workspace-dump";

export const UserDump = z.object({
  user: User,
  workspaces: WorkspaceDump.array(),
});

export type UserDump = z.infer<typeof UserDump>;
